import styled, { css } from "styled-components/native";
import {
  pickStyle as _,
  getViewHeight as h,
  pickThemeKey as theme,
} from "utils";

import {
  LogoSpace,
  LogoWidth,
  LogoHeight,
  TextSpacing,
  FontSize,
  ButtonMargin,
} from "./variables";

export const Container = styled.View`
  height: 100vh;
  align-items: center;
  background-color: ${theme("background")};
`;

export const BgImage = styled.Image`
  height: 100%;
  position: absolute;
  resize-mode: cover;
  width: 100%;
  z-index: 0;
`;

export const ImageHolder = styled.View`
  height: ${theme("height_logo") || _(LogoWidth) || 150}px;
  width: ${theme("width_logo") || _(LogoHeight) || 75}px;
  margin-top: ${theme("margin_top_logo") || _(LogoSpace) || 161}px;
`;

export const LogoImage = styled.Image`
  height: ${theme("height_logo")};
  width: ${theme("width_logo")};
  resize-mode: contain;
`;

export const ThankYouImageContainer = styled.View`
  width: 200px;
  height: 200px;
  margin-top: 30vh;
`;

export const PoweredByImageContainer = styled.View`
  width: 180px;
  height: 90px;
  resize-mode: contain;
`;

export const PoweredByText = styled.Text`
  margin-right: 12px;
  font-weight: bold;
`;

export const ThankYouImage = styled.Image`
  height: 100%;
  width: 100%;
  resize-mode: contain;
`;

export const TextHolder = styled.View`
  ${props =>
    props.$isThankYou
      ? css`
          margin-top: 30px;
        `
      : css`
          flex: 1;
        `}
  justify-content: center;
  padding: 0 ${_(TextSpacing) || 0}px;
`;

export const WelcomeText = styled.Text`
  font-size: ${theme("home_text_size") || _(FontSize) || 26}px;
  color: ${theme("home_text")};
  font-family: ${theme("home_text_style") || "Roboto"};
  max-width: 804px;
  margin: 0 auto;
  text-align: center;
  line-height: 30px;
`;

export const ButtonHolder = styled.View`
  margin-bottom: ${_(ButtonMargin) || 120}px;
`;

export const StartButton = styled.TouchableOpacity`
  background-color: ${theme("home_button")};
  border-radius: 3px;
  border: 1px ${theme("home_button")};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  padding: 5px;
  margin: 5px;
  text-align: center;
`;

export const StartText = styled.Text`
  font-size: ${theme("home_button_text_size") || 22}px;
  font-family: ${theme("home_button_text_style") || "Roboto"};
  line-height: 25px;
  color: ${theme("home_button_text")};
`;

export const StartImage = styled.Image`
  height: 12px;
  width: 20px;
  margin-left: 16px;
  tint-color: ${theme("home_button_text")};
`;

export const ErrorMessage = styled.Text`
  text-align: center;
  color: ${theme("home_info_text") || "white"};
  font-size: ${theme("home_info_text_size")}px;
  font-family: ${theme("home_info_text_style")};
`;
